<template>
<div>
<Profile/>

</div>
</template>
<script>
import Profile from "../components/Profile.vue";

export default {
  beforeCreate: function() {
        document.body.className = 'iner';
    },
  components: {
   Profile
  },
  data() {
    return {
      content: ''
    };
  },
  created() {

  }
};
</script>

<style>


</style>